import { render, staticRenderFns } from "./request-ipf.vue?vue&type=template&id=ec0b2a6e&lang=html"
import script from "./request-ipf.vue?vue&type=script&lang=js"
export * from "./request-ipf.vue?vue&type=script&lang=js"
import style0 from "./request-ipf.vue?vue&type=style&index=0&id=ec0b2a6e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports